import { OrdenServicio } from './ordenServicio';

export class OrdenServicioPago extends OrdenServicio {
    saldo: number;
    vencido: number;
    xVencer: number;
    selected: boolean;
    buscando: boolean;
    aseguradora: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/pagos.ts